// src/components/Loading.js
import React from 'react';
import '../scss/components/_loading.scss';

export default function Loading() {
  return (
    <div className="loading-overlay">
      <div className="spinner"></div>
    </div>
  );
}
